import React from "react";

const CapabilitiesTextContainer = (props: { children: React.ReactNode }) => {
  return (
    <div className="p-4 border border-border-gray90 rounded-[8px] text-base font-normal h-full">
      {props.children}
    </div>
  );
};

export default CapabilitiesTextContainer;
